import type { ReactNode } from "react";
import { cn } from "../../lib/cn";

interface ShinyTextProps {
  children: ReactNode;
  className?: string;
  shimmerWidth?: number;
  speed?: number;
}

export function ShinyText({
  children,
  className = "",
  speed = 3
}: ShinyTextProps) {
  return (
    <span
      className={cn(
        "shiny-text inline-block bg-clip-text text-transparent",
        className
      )}
      style={{
        // Khai báo nền trực tiếp để chữ vẫn hiển thị khi Tailwind tối ưu utility.
        backgroundImage: "linear-gradient(110deg, hsl(var(--muted-foreground)) 35%, hsl(var(--foreground)) 50%, hsl(var(--muted-foreground)) 65%)",
        backgroundSize: "200% 100%",
        animation: `shiny-shimmer ${speed}s ease-in-out infinite`
      }}
    >
      {children}
    </span>
  );
}
